import { useFdrWishlistOverviewQuery } from 'fdr/schemas/query/wishlist/fdr-wishlist-overview.generated';

export function useWishlistOverview() {
  const { data, previousData } = useFdrWishlistOverviewQuery({
    ssr: false,
    fetchPolicy: 'cache-and-network',
  });

  const wishlists = (data || previousData)?.fdrWishlists?.wishlists;

  return {
    wishlists: wishlists || [],
    loading: !wishlists,
  };
}
